import React, { useState } from 'react';
import { waitlist as waitlistApi } from '../services/api';

// DEMO MODE: real booking is disabled site-wide. This form only captures an
// email address for the launch waitlist — it never touches Stripe.
export default function WaitlistForm({ price }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [errorMsg, setErrorMsg] = useState('');

  async function submit(e) {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');
    try {
      await waitlistApi.join(email);
      setStatus('sent');
    } catch (err) {
      setErrorMsg(err.response?.data?.error || 'Something went wrong. Please try again.');
      setStatus('error');
    }
  }

  if (status === 'sent') {
    return (
      <div className="alert alert-success" style={{ margin: 0, textAlign: 'center' }}>
        You're on the list! We'll email you when booking opens.
      </div>
    );
  }

  return (
    <div>
      {price && (
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--ink-muted)', textAlign: 'center', marginBottom: '0.75rem' }}>
          Current demo price: <strong>{price}</strong>
        </p>
      )}

      {!open ? (
        <button type="button" className="btn btn-primary btn-full" onClick={() => setOpen(true)}>
          Coming Soon — Join the Waitlist
        </button>
      ) : (
        <form onSubmit={submit}>
          {status === 'error' && <div className="alert alert-error">{errorMsg}</div>}
          <div className="form-group" style={{ marginBottom: '0.75rem' }}>
            <label htmlFor="waitlist-email">Email address</label>
            <input
              id="waitlist-email"
              type="email"
              required
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={status === 'sending'}>
            {status === 'sending' ? 'Joining…' : 'Join the Waitlist'}
          </button>
        </form>
      )}

      <p style={{ fontSize: 'var(--text-xs)', color: 'var(--ink-faint)', marginTop: '0.75rem', textAlign: 'center' }}>
        Booking is not yet available. We'll let you know as soon as it is.
      </p>
    </div>
  );
}
